import { formatMoney } from '../utils/currencyUtil';
import { POS_SUBSCRIPTION_REVIEW_WINDOW, POS_SUBSCRIPTION_VENDOR_NAME } from '../constants/posConst';
import '../css/PosSubscription.css';

/**
 * The last step of Subscribe: the application was received, and what happens
 * next.
 *
 * @param {object} props
 * @param {object} props.application - as returned by submitSubscriptionApplication
 * @param {object} props.config - for the currency symbol
 * @returns {JSX.Element}
 */
function PosSubscribeConfirmation({ application, config }) {
  return (
    <div className="ps-confirm">
      <h4 className="ps-confirm-title">Application submitted</h4>
      <p>
        Thank you. Your subscription application for <strong>{application.planName}</strong>
        {' '}({formatMoney(application.total, config)}) and your proof of payment have been received.
      </p>
      <p>
        {POS_SUBSCRIPTION_VENDOR_NAME} will review your application and verify your payment. Reviews
        are completed within {POS_SUBSCRIPTION_REVIEW_WINDOW}. Once approved, your subscription is
        activated automatically — the notice at the top of this screen will update, and there is
        nothing further you need to do.
      </p>
      {(application.extraStaffEmails || []).length > 0 && (
        <p>
          The additional staff accounts you requested will be added to this till on approval.
        </p>
      )}
      <p className="ps-muted">
        If the payment cannot be verified, the reason will be shown here and you may apply again.
        Please keep your receipt until your subscription is active.
      </p>
      <p className="ps-ref">Reference: <code className="pa-code">{application.id}</code></p>
    </div>
  );
}

export default PosSubscribeConfirmation;
